// Color options for customization - EXACT MATCH from mobile

export const LABEL_COLOR_OPTION = [
  {
    name: 'Asda Green',
    value: '#22e39e',
  },
  {
    name: 'Lemon meringue',
    value: '#F1E5BC',
  },
  {
    name: 'Azureish white',
    value: '#DDECF0',
  },
  {
    name: 'Gin',
    value: '#CDE3C1',
  },
  {
    name: 'Palw blue',
    value: '#C5E9E3',
  },
  {
    name: 'Twitter blue',
    value: '#4EA5D2',
  },
  {
    name: 'English violet',
    value: '#524364',
  },
  {
    name: 'Yellow',
    value: '#ffd700',
  },
  {
    name: 'Violet',
    value: '#ee82ee',
  },
  {
    name: 'Pink',
    value: '#ffc022',
  },
  {
    name: 'Azureish white',
    value: '#DDEC23',
  },
  {
    name: 'Gin',
    value: '#CDE332',
  },
  {
    name: 'Palw blue',
    value: '#C5E9E5',
  },
  {
    name: 'Twitter blue',
    value: '#4EA5D1',
  },
  {
    name: 'English violet',
    value: '#524362',
  },
  {
    name: 'Yellow',
    value: '#ffd711',
  },
  {
    name: 'Violet',
    value: '#ee82ee',
  },
  {
    name: 'Pink',
    value: '#ffc0cb',
  },
  {
    name: 'Bronze',
    value: '#CD7F32',
  },
  {
    name: 'Tan',
    value: '#D2B48C',
  },
  {
    name: 'Teal',
    value: '#008080',
  },
  {
    name: 'Coral',
    value: '#FF7F50',
  },
  {
    name: 'Lavender',
    value: '#E6E6FA',
  },
  {
    name: 'Mauve',
    value: '#E0b0FF',
  },
  {
    name: 'Peach',
    value: '#FFE5B4',
  },
  {
    name: 'Turquoise',
    value: '#30D5C8',
  },
  {
    name: 'Amber',
    value: '#FFBF00',
  },
  {
    name: 'Mint',
    value: '#3EB489',
  },
  {
    name: 'DarkKhaki',
    value: '#BDB76B',
  },
  {
    name: 'MediumOrchid',
    value: '#BA55D3',
  },
  {
    name: 'Indigo',
    value: '#4B0082',
  },
  {
    name: 'MediumSeaGreen',
    value: '#3CB371',
  },
  {
    name: 'YellowGreen',
    value: '#9ACD32',
  },
  {
    name: 'Turquoise',
    value: '#40E0D0',
  },
  {
    name: 'SteelBlue',
    value: '#4682B4',
  },
  {
    name: 'BurlyWood',
    value: '#DEB887',
  },
  {
    name: 'Goldenrod',
    value: '#DAA520',
  },
  {
    name: 'MediumSlateBlue',
    value: '#7B68EE',
  },
  {
    name: 'DimGray',
    value: '#696969',
  },
  {
    name: 'LightSlateGray',
    value: '#778899',
  },
  {
    name: 'Beige',
    value: '#F5F5DC',
  },
];

export const STATUS_COLOR_OPTION = [
  {
    name: 'Maroon',
    value: '#72002B',
  },
  {
    name: 'Plum dyed ',
    value: '#F68E4F',
  },
  {
    name: 'Sun Ray',
    value: '#E5B464',
  },
  {
    name: 'Shampoo',
    value: '#FFC5F3',
  },
  {
    name: 'Codet Blue',
    value: '#649EA2',
  },
  {
    name: 'Irresistible',
    value: '#BA4769',
  },
  {
    name: 'Hot Pink',
    value: '#FF70BD',
  },
  {
    name: 'Emerald',
    value: '#50C878',
  },
  {
    name: 'Azure',
    value: '#1520A6',
  },
  {
    name: 'Electric',
    value: '#7EF9FF',
  },
];

export const COLOR_OPTIONS = [
  {
    name: 'Light Green',
    value: '#22e39e',
  },
  {
    name: 'Red',
    value: '#F1E5BC',
  },
  {
    name: 'Green',
    value: '#32cd32',
  },
  {
    name: 'Blue',
    value: '#0000ff',
  },
  {
    name: 'Yellow',
    value: '#ffd700',
  },
  {
    name: 'Violet',
    value: '#ee82ee',
  },
  {
    name: 'Pink',
    value: '#ffc0cb',
  },
  {
    name: 'Black',
    value: '#000',
  },
  ...LABEL_COLOR_OPTION,
  ...STATUS_COLOR_OPTION,
];

// Helper function to get next available color
export const getNextColor = (existingColors: string[], colorSet: typeof COLOR_OPTIONS = COLOR_OPTIONS): string => {
  // Filter out colors already in use
  const availableColors = colorSet.filter(c => !existingColors.includes(c.value));

  // Return first available, or cycle back to start if all used
  return availableColors.length > 0 ? availableColors[0].value : colorSet[0].value;
};
